import { BinaryId, LoginResult, RpcDefinition } from "@litbase/core";

export const inviteUser = new RpcDefinition<[{ email: string; name: string }], Promise<unknown>>("inviteUser");
export const acceptInviteFunction = new RpcDefinition<[token: string, password: string], Promise<LoginResult>>(
  "acceptInvite",
);
export const setNotificationEnabled = new RpcDefinition<[notificationId: BinaryId, enabled: boolean], Promise<void>>(
  "setNotificationEnabled",
);
